import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettingsService } from 'src/app/core/services/settings.service';
import { DiscountFormComponent } from './discount-form/discount-form.component';

@Component({
  selector: 'app-discount-master',
  templateUrl: './discount-master.component.html',
  styleUrls: ['./discount-master.component.scss']
})

export class DiscountMasterComponent {

  breadCrumbItems: Array<{}>;
  pageSize = 10;
  pageNumber = 0;
  page_details: any = {
    count: 0,
    next: '',
    previous: ''
  };

  discountList: any = [];
  isLoading = false;

  constructor(private api: SettingsService, private modalService: NgbModal, public toastr: ToastrService) { }

  ngOnInit(): void {
    this.breadCrumbItems = [{ label: 'Settings' }, { label: 'Discount Master', active: true }];
    this.getDiscounts(this.pageSize, 0);
  }

  getDiscounts(
    limit: number,
    offset: number
  ) {
    this.discountList = [];
    this.isLoading = true;
    const params: { [key: string]: any } = { limit, offset };

    this.api.getDiscountList(params).subscribe(
      (result: any) => {
        this.isLoading = false;
        this.discountList = result?.results || [];
        this.page_details = {
          count: result?.count,
          next: result?.next,
          previous: result?.previous
        }
      }, () => {
        this.isLoading = false;
      })
  }

  nextPage(page) {
    this.getDiscounts(this.pageSize, this.pageSize * (page - 1));
  }

  showDiscountModal(id?) {
    const modalRef = this.modalService.open(DiscountFormComponent,
      {
        size: 'lg',
        scrollable: true,
        windowClass: 'modal-big-lg',
        keyboard: false,
        backdrop: 'static'
      });
    modalRef.componentInstance.discountId = id;

    modalRef.result
      .then((result) => {
        if (result) {
          this.getDiscounts(this.pageSize, this.pageSize * (this.pageNumber - 1));
        }
      })
      .catch(() => { });
  }

  discountStatus(discount: any) {
    const data = {
      id: discount.id,
      is_active: discount.is_active
    };
    this.api.updateDiscountStatus(discount.id, data).subscribe(
      () => {
        if (discount.is_active) this.toastr.success(`Discount ${discount.discount_name} is active.`);
        else this.toastr.warning(`Discount ${discount.discount_name} is inactive.`);
      },
      () => {
        this.toastr.error("Try Again!", "Something went wrong.");
      }
    )
  }

}
